import InboxesAPI from 'dashboard/api/inboxes';
import { getWhatsappTemplateErrorMessage } from 'dashboard/helper/templateHelper';

export const cloudInboxes = inboxes =>
  (inboxes || []).filter(
    inbox =>
      inbox.channel_type === 'Channel::Whatsapp' &&
      inbox.provider === 'whatsapp_cloud'
  );

const businessKey = inbox =>
  inbox.provider_config?.business_account_id || `inbox:${inbox.id}`;

export const groupInboxes = inboxes => {
  const groups = new Map();
  cloudInboxes(inboxes).forEach(inbox => {
    const key = String(businessKey(inbox));
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(inbox);
  });
  return [...groups.values()];
};

// Each request targets one WABA. Successful destinations are retained on retry.
export async function distributeTemplate({
  inboxes,
  template,
  file,
  preparedInbox,
  previousResults = [],
  errorMessage,
  onProgress = () => {},
}) {
  const results = previousResults.filter(result => result.success);
  await groupInboxes(inboxes).reduce(async (previous, group) => {
    await previous;
    if (
      group.some(inbox => results.some(result => result.inboxId === inbox.id))
    )
      return;
    const inbox = group.find(item => item.id === preparedInbox.id) || group[0];
    let result;
    try {
      const payload = { ...template };
      if (file && businessKey(inbox) !== businessKey(preparedInbox)) {
        const { data } = await InboxesAPI.uploadWhatsappTemplateMedia(
          inbox.id,
          file,
          template.header_format
        );
        if (!data.handle) throw new Error('missing media handle');
        payload.header_handle = data.handle;
      }
      const { data } = await InboxesAPI.createWhatsappTemplate(
        inbox.id,
        payload
      );
      result = { success: true, template: data.template };
    } catch (error) {
      result = {
        success: false,
        error: getWhatsappTemplateErrorMessage(error, errorMessage),
      };
    }
    results.push(
      ...group.map(item => ({ inboxId: item.id, name: item.name, ...result }))
    );
    onProgress([...results]);
  }, Promise.resolve());
  return results;
}
